// Keep React version detection isolated since mocking React itself causes test issues.
// This can be removed once all supported React versions accept Fragment refs.
import { version } from 'react';
const getReactVersion = () => {
    const [major, minor, patch] = version.split('.').map((str) => Number.parseInt(str, 10));
    return [major, minor, patch];
};
export default getReactVersion;
